/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';

import { getLabelByTypeId } from '../../../utils/types';

const EventHealthAndSafetyCard = ({ event, 'data-testid': dataTestId }) => {
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const { eventHealthProtocolTypes } = coreUI.types.tms;
    const getId = (protocol) => {
        return protocol.hasOwnProperty('id') ? protocol.id : protocol.protocolTypeId;
    };
    return (
        <div className={`utr-card p-2 d-flex flex-column justify-content-around`}>
            {event.healthAndSafetyProtocols.map(protocol => (
                <div className={`px-2 my-2 d-flex justify-content-start align-items-center`} key={`p-${getId(protocol)}`}>
                    <i className="mr-4 text-teal fas fa-circle" />
                    <p className="text-line-break m-0 fs12 text-left" data-testid={dataTestId && `${dataTestId}.protocol-${getId(protocol)}.label`}>{getLabelByTypeId(eventHealthProtocolTypes, getId(protocol))}</p>
                </div>
            ))}
            {event.additionalSafetyInformation && (
                <div className={`px-2 my-2 d-flex justify-content-start align-items-center`}>
                    <i className="mr-4 text-teal fas fa-circle" />
                    <p className="text-line-break m-0 fs12 text-left" data-testid={dataTestId && `${dataTestId}.additional-safety-info`}>{event.additionalSafetyInformation}</p>
                </div>
            )}
        </div>
    );
};

export default EventHealthAndSafetyCard;
